export const LOW = '1';
export const MEDIUM = '2';
export const HIGH = '3';
export const MAJOR = '4';

